import React from "react";
import styled from "styled-components";
import { Table as BsTable } from "react-bootstrap";
import { PagoVenta } from "../../services/ventasServicios";
import { currencyFormat } from "../../utils/numberUtils";
import { formatearFechaStr } from "../../utils/dateUtils";

function PagosTable({ items }: { items: PagoVenta[] }) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>Fecha</StyledColHeader>
          <StyledColHeader>Monto</StyledColHeader>
          <StyledColHeader>Método</StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <TableItem key={item.id} item={item} />
        ))}
      </tbody>
    </StyledTable>
  );
}

function TableItem({ item }: { item: PagoVenta }) {
  return (
    <StyledRow>
      <StyledCell>{formatearFechaStr(item.fecha)}</StyledCell>
      <StyledCell>{currencyFormat(item.monto)}</StyledCell>
      <StyledCell>{item.metodo}</StyledCell>
    </StyledRow>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

export default PagosTable;
